import { type CategoryKey } from "@src/components/Dialogs/CreateExperienceDialog/types";
import {
  SMART_CHECKOUT_ID,
  SMART_CONTENT_ID,
  SMART_MERCHANDISING_ID,
  SMART_PRICING_LIMITED_ID,
  SMART_PRICING_UNLIMITED_ID,
  SMART_SHIPPING_ID,
} from "@src/constants/billing";

interface ModuleEmptyStateCopy {
  heading: string;
  description: string;
  buttonLabel: string;
}

export const MODULE_EMPTY_STATE_COPY = {
  content: {
    heading: "Discover content that converts",
    description:
      "Run A/B tests and personalize your storefront content to match what actually converts.",
    buttonLabel: "New Content Experience",
  },
  merchandising: {
    heading: "Turn browsers into bigger buyers",
    description:
      "Test bundle offers, progress bars, and more to drive higher cart values before checkout.",
    buttonLabel: "New Merchandising Experience",
  },
  pricing: {
    heading: "Upgrade to find your perfect price point",
    description:
      "A/B test prices in real time to discover the sweet spot that maximizes profit, revenue, and conversion.",
    buttonLabel: "New Pricing Experience",
  },
  shipping: {
    heading: "Optimize every shipping decision",
    description:
      "Test and personalize shipping rates, free shipping thresholds, and offers to reduce cart abandonment.",
    buttonLabel: "New Shipping Experience",
  },
  checkout: {
    heading: "Make more money at checkout",
    description:
      "Test and personalize on recommended products, offers, and trust signals to convert more at checkout.",
    buttonLabel: "New Checkout Experience",
  },
  postPurchase: {
    heading: "Make more money on every order",
    description:
      "A/B test and personalize post-purchase offers, recommended products, and one-click add.",
    buttonLabel: "New Post-purchase Experience",
  },
} satisfies Record<CategoryKey, ModuleEmptyStateCopy>;

export const MODULE_TRIAL_DESCRIPTION: Readonly<Record<string, string>> = {
  [SMART_CONTENT_ID]: MODULE_EMPTY_STATE_COPY.content.description,
  [SMART_MERCHANDISING_ID]: MODULE_EMPTY_STATE_COPY.merchandising.description,
  [SMART_PRICING_LIMITED_ID]: MODULE_EMPTY_STATE_COPY.pricing.description,
  [SMART_PRICING_UNLIMITED_ID]: MODULE_EMPTY_STATE_COPY.pricing.description,
  [SMART_SHIPPING_ID]: MODULE_EMPTY_STATE_COPY.shipping.description,
  [SMART_CHECKOUT_ID]:
    "A/B test and personalize checkout offers, trust signals, and recommended products, plus post-purchase offers with one-click add.",
};
